import React, { useEffect, useState } from "react";
import { listAllClassAttendance, classSecitionList } from "../../../services/attendance";
import { academylist } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment";

export default function Classwiseattendance() {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cdate, setCDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [acaid, setAcaID] = useState("");
  const [aclist, setAcList] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      academylist().then((res) => {
        if (res.status === true) {
          const arr = res.data.details.map((item) => ({
            value: item.id,
            label: item.name + " - " + item.code,
          }));
          setAcList(arr);
        }
      });
    } else {
      const today = moment(new Date()).format("YYYY-MM-DD");
      fetchData(today, localStorage.getItem("academy") || 0);
    }

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          const matched = res.data.details.find(
            (d) => d.id == localStorage.getItem("AAcademy")
          );
          if (matched) {
            const sel = { value: matched.id, label: matched.name + " - " + matched.code };
            setAcaID(sel);
            fetchData(moment(new Date()).format("YYYY-MM-DD"), matched.id);
          }
        }
      });
    }
  }, []);

  function fetchData(date, aca) {
    setLoading(true);
    Promise.all([
      classSecitionList(aca || 0),
      listAllClassAttendance(date, date, 0, aca, 4),
    ]).then(([secRes, attRes]) => {
      setLoading(false);

      const allSections = secRes && secRes.status === true ? secRes.data : [];

      const attendanceMap = {};
      if (attRes && attRes.status === true) {
        attRes.data.forEach((item) => {
          const key = item.class_name + "||" + item.section_name;
          const morning = item.TimeStatus.find((t) => t.Time === "Morning") || {};
          // Second slot accepts both legacy "Afternoon" and current "Evening".
          const afternoon = item.TimeStatus.find((t) => t.Time === "Afternoon" || t.Time === "Evening") || {};
          attendanceMap[key] = {
            total: item.total_students,
            morning_present: morning.present_count || 0,
            morning_absent: morning.absent_count || 0,
            afternoon_present: afternoon.present_count || 0,
            afternoon_absent: afternoon.absent_count || 0,
          };
        });
      }

      if (allSections.length === 0 && Object.keys(attendanceMap).length === 0) {
        setAttendanceData([]);
        return;
      }

      const merged = allSections.map((sec) => {
        const key = sec.class_name + "||" + sec.section_name;
        const att = attendanceMap[key] || {};
        return {
          class_name: sec.class_name,
          section_name: sec.section_name,
          total: att.total !== undefined ? att.total : sec.total_students,
          morning_present: att.morning_present || 0,
          morning_absent: att.morning_absent || 0,
          afternoon_present: att.afternoon_present || 0,
          afternoon_absent: att.afternoon_absent || 0,
        };
      });

      // Also include any attendance entries not covered by the section list
      Object.keys(attendanceMap).forEach((key) => {
        const exists = merged.some((m) => m.class_name + "||" + m.section_name === key);
        if (!exists) {
          const [class_name, section_name] = key.split("||");
          merged.push({ class_name, section_name, ...attendanceMap[key] });
        }
      });

      setAttendanceData(merged);
    });
  }

  function handleDateChange(e) {
    const date = e.target.value;
    setCDate(date);
    const aca = localStorage.getItem("Role") === "1"
      ? acaid !== "" ? acaid.value : 0
      : localStorage.getItem("academy") || 0;
    fetchData(date, aca);
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      fetchData(cdate, e.value);
    } else {
      setAcaID("");
      setAttendanceData([]);
    }
  }

  const totalPresent = attendanceData.reduce((s, r) => s + r.morning_present, 0);
  const totalAbsent = attendanceData.reduce((s, r) => s + r.morning_absent, 0);
  const totalStudents = attendanceData.reduce((s, r) => s + r.total, 0);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Class Wise Attendance</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Attendance</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Class Wise Attendance
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="container-fluid">

            {/* Filters */}
            <div className="row row-sm mb-4">
              {localStorage.getItem("Role") === "1" && (
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3">
                  <label className="form-label">Select Academy</label>
                  <Select
                    className="default-select"
                    placeholder="Select Academy"
                    value={acaid}
                    options={aclist}
                    onChange={handleAcademy}
                    isSearchable={true}
                    isClearable
                  />
                </div>
              )}
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={cdate}
                  onChange={handleDateChange}
                />
              </div>
            </div>

            {/* Summary strip */}
            {attendanceData.length > 0 && (
              <div className="row row-sm mb-4">
                <div className="col-xl-4 col-md-4 col-sm-6 mb-3">
                  <div className="card custom-card" style={{ borderTop: "3px solid #6259ca" }}>
                    <div className="card-body text-center py-3">
                      <h2 className="mb-1 font-weight-bold text-primary">{totalStudents}</h2>
                      <p className="text-muted mb-0">Total Students</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-4 col-sm-6 mb-3">
                  <div className="card custom-card" style={{ borderTop: "3px solid #19b159" }}>
                    <div className="card-body text-center py-3">
                      <h2 className="mb-1 font-weight-bold text-success">{totalPresent}</h2>
                      <p className="text-muted mb-0">Total Present</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-4 col-sm-6 mb-3">
                  <div className="card custom-card" style={{ borderTop: "3px solid #f16d75" }}>
                    <div className="card-body text-center py-3">
                      <h2 className="mb-1 font-weight-bold text-danger">{totalAbsent}</h2>
                      <p className="text-muted mb-0">Total Absent</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Attendance Status */}
            {attendanceData.length > 0 && (
              <div className="card custom-card mt-1 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 text-white">Attendance Status</h5>
                  <div className="d-flex gap-3">
                    <span className="text-white me-3">
                      <span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#28a745", marginRight: 4 }}></span>
                      Marked
                    </span>
                    <span className="text-white">
                      <span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#dc3545", marginRight: 4 }}></span>
                      Not Marked
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    {attendanceData.map((item, i) => {
                      const isMarked = item.morning_present + item.morning_absent > 0 || item.afternoon_present + item.afternoon_absent > 0;
                      return (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2" key={i}>
                          <div className="text-center py-2 px-1 rounded" style={{
                            backgroundColor: isMarked ? "#d4edda" : "#f8d7da",
                            border: `1px solid ${isMarked ? "#28a745" : "#dc3545"}`,
                          }}>
                            <span className="fw-bold tx-13" style={{ color: isMarked ? "#155724" : "#721c24" }}>
                              {item.class_name} - {item.section_name}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Class-wise cards */}
            {attendanceData.length === 0 && !loading && (
              <div className="text-center mt-5">
                <p className="text-muted">No classes found for the selected academy.</p>
              </div>
            )}

            <div className="row row-sm">
              {attendanceData.map((item, i) => (
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" key={i}>
                  <div className="card custom-card h-100">
                    <div className="card-bodyy">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="product-content">
                            <h3 className="title text-center mb-0">
                              <a>{item.class_name} - {item.section_name}</a>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Morning */}
                    <div className="text-center pt-1">
                      <small className="text-danger fw-bold">Morning</small>
                    </div>
                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-primary">{item.total}</span>
                          <p className="text-muted tx-12 mb-0">Total</p>
                        </h4>
                      </div>
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-success">{item.morning_present}</span>
                          <p className="text-muted tx-12 mb-0">Present</p>
                        </h4>
                      </div>
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-danger">{item.morning_absent}</span>
                          <p className="text-muted tx-12 mb-0">Absent</p>
                        </h4>
                      </div>
                    </div>

                    {/* Afternoon */}
                    <div className="text-center pt-2">
                      <small className="text-danger fw-bold">Afternoon</small>
                    </div>
                    <div className="row sales-product-infomation pb-2 mb-0 mx-auto wd-100p">
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-primary">{item.total}</span>
                          <p className="text-muted tx-12 mb-0">Total</p>
                        </h4>
                      </div>
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-success">{item.afternoon_present}</span>
                          <p className="text-muted tx-12 mb-0">Present</p>
                        </h4>
                      </div>
                      <div className="col-4 text-center">
                        <h4 className="mb-1 font-weight-bold">
                          <span className="text-danger">{item.afternoon_absent}</span>
                          <p className="text-muted tx-12 mb-0">Absent</p>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
